var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main-content"},[_c('div',{staticClass:"content-container"},[_c('chat-interface',{ref:"chatInterface"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }